/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Linear_Kb8Inputs */

const en_mk_cmp_linear_kb8 = /** @type {(inputs: Mk_Cmp_Linear_Kb8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Still thin; the focus is inside its own workspace.`)
};

const id_mk_cmp_linear_kb8 = /** @type {(inputs: Mk_Cmp_Linear_Kb8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masih sedikit; fokusnya di dalam ruang kerja sendiri.`)
};

/**
* | output |
* | --- |
* | "Still thin; the focus is inside its own workspace." |
*
* @param {Mk_Cmp_Linear_Kb8Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_linear_kb8 = /** @type {((inputs?: Mk_Cmp_Linear_Kb8Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Linear_Kb8Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_linear_kb8(inputs)
	return en_mk_cmp_linear_kb8(inputs)
});